import React, { PureComponent, Fragment } from 'react';
import Button from '@material-ui/core/Button';
import getErrorsFromResponse from 'Components/Forms/Functions/getErrorsFromResponse';
import ServiceCard from 'Components/Front/ServiceCard';
import LeftArrowIcon from 'Icons/LeftArrowIcon';
import bemit from 'Functions/bemit';
import { num } from 'Shared/utilities';
import { service_categories } from 'Shared/options';
import { action } from 'Shared/Routes';
import { getBookingServiceRowPrices } from '../../../../FullStack/Shared/utilities';
const {
  app,
  qwest
} = window;
export default class Services extends PureComponent {
  state = {
    loading: false,
    status_messages: {},
    categories: [],
    page_width: window.innerWidth
  };
  componentDidMount() {
    const component = this,
      props = this.props,
      state = this.state;
    component.fetchServices();
    app.push({
      event: 'window.resize',
      cb: component.handleResize
    });
  }
  componentWillUnmount() {
    const component = this,
      props = this.props,
      state = this.state;
    app.delete({
      event: 'window.resize',
      cb: component.handleResize
    });
  }
  handleResize = ({
    source
  }) => {
    const component = this,
      props = this.props,
      state = this.state;
    component.setState({
      page_width: window.innerWidth
    });
  };
  componentDidUpdate(prevProps, prevState) {
    const component = this,
      props = this.props,
      state = this.state;
    if (state.date && prevState.date !== state.date) {
      component.fetchServices();
    }
    Object.keys(state).filter(data => data.startsWith('qty_')).forEach(function (data) {
      if (prevState[data] !== state[data]) {
        const services = component.getCurrentServices();
        props.updateCart(services);
      }
    });
  }
  fetchServices = () => {
    const component = this,
      props = this.props,
      state = this.state;
    component.setState({
      loading: true
    });
    qwest.post(action('getAllServices'), {
      space_id: props.space.id,
      front: true
    }).then(function (xhr, response) {
      const services_by_category = (response.data || []).reduce(function (grouped, service) {
        const category = service._servicetitle?.__category;
        if (!grouped[category?.value || '']) {
          grouped[category?.value || ''] = [];
        }
        grouped[category?.value || ''].push(service);
        return grouped;
      }, {});
      const update = {
        loading: false,
        services_count: 0,
        categories: Object.keys(services_by_category).map(function (id) {
          const category = service_categories.find(opt => opt.value === id) || {
            value: ''
          };
          return {
            ...category,
            __services: services_by_category[id]
          };
        })
      };
      update.categories.forEach(function (category) {
        update.services_count += category.__services.length;
        category.__services.forEach(function (service) {
          update['qty_' + service.id] = '0';
        });
      });
      component.setState(update);
    }).catch(function (error, xhr, response) {
      console.error(response?.error || response?.raw || error);
      component.setState({
        ...getErrorsFromResponse({
          response: response
        })
      });
    });
  };
  getCurrentServices = () => {
    const component = this,
      props = this.props,
      state = this.state;
    const services = [];
    Object.keys(state).filter(data => data.startsWith('qty_') && parseInt(state[data], 10) > 0).forEach(function (data) {
      const quantity = num(state[data], 0);
      const service_id = data.split('qty_')[1];
      const service = {};
      service.service_info = component.getService(service_id);
      const service_title = service.service_info._servicetitle ? service.service_info._servicetitle.title : service.service_info.title;
      service.service_info.title = service_title;
      Object.assign(service, getBookingServiceRowPrices({
        service: service.service_info,
        hours_count: props.hours_count,
        quantity: quantity
      }));
      service.quantity = quantity;
      services.push(service);
    });
    return services;
  };
  getService(id, categories) {
    const component = this,
      props = this.props,
      state = this.state;
    let match;
    (categories || state.categories).find(function (category) {
      match = category.__services.find(service => service.id === id);
      return match ? true : false;
    });
    return match;
  }
  nextStep = () => {
    const component = this,
      props = this.props,
      state = this.state;
    const services = component.getCurrentServices();
    props.nextStep(services);
  };
  handleQuantityChange = ({
    e,
    value,
    name
  }) => {
    const component = this,
      props = this.props,
      state = this.state;
    component.setState({
      [name]: value,
      has__picked_service: value > 0 ? true : Object.keys(state).filter(field => field.startsWith('qty_') && field !== name).some(name => parseInt(state[name], 10) > 0)
    });
  };
  render() {
    const component = this,
      props = this.props,
      state = this.state;
    const categories = (state.categories || []).map(function (category, i) {
      const services = category.__services.map(function (service) {
        const output = /*#__PURE__*/React.createElement(ServiceCard, {
          key: service.id,
          service: service,
          onChange: component.handleQuantityChange,
          status: state.status_messages,
          value: state['qty_' + service.id],
          people: props.people,
          start: props.start,
          end: props.end,
          bemit: props['white-label-booking'] ? ['white-label-booking'] : undefined
        });
        return output;
      });

      // mobile & tablet
      const has__widget = window.innerWidth > 1200 && i === 0;
      const modifiers = ['front'].concat(has__widget ? ['with-widget'] : []);
      if (props['white-label-booking']) {
        modifiers.push('white-label-booking');
      }
      const output = /*#__PURE__*/React.createElement("div", {
        className: bemit('c-booking-category', modifiers),
        key: category.value
      }, /*#__PURE__*/React.createElement("h3", {
        className: "c-booking-category__title"
      }, category.label), /*#__PURE__*/React.createElement("div", {
        className: "c-booking-category__services"
      }, services), has__widget && props['cart-widget'] ? /*#__PURE__*/React.createElement("div", {
        className: "c-booking-category__widget"
      }, props['cart-widget']) : undefined);
      return output;
    });
    const go_back_btn = /*#__PURE__*/React.createElement(Button, {
      type: "button",
      onClick: props.goBack,
      className: bemit('c-arrow-btn', ['primary'])
    }, /*#__PURE__*/React.createElement(LeftArrowIcon, {
      className: "c-arrow-btn__arrow"
    }), /*#__PURE__*/React.createElement("span", {
      className: "c-arrow-btn__text"
    }, "Retour \xE0 l'\xE9tape pr\xE9c\xE9dente"));
    const book_btn = /*#__PURE__*/React.createElement(Button, {
      className: bemit('c-flat-btn', ['blue', 'v2', 'cart-step']) + (props?.fromBack ? ' u-margin-auto' : ''),
      onClick: component.nextStep
    }, state.has__picked_service ? 'Valider et passer à la réservation' : 'Passer cette étape');
    const bottom_btn = props['white-label-booking'] ? /*#__PURE__*/React.createElement("div", {
      className: "c-direct-booking_header\r c-direct-booking_header--services\r c-direct-booking_header--services-mobile"
    }, go_back_btn, book_btn) : !(state.services_count > 5 || categories.length > 0) ? undefined : props.fromBack ? /*#__PURE__*/React.createElement("div", {
      className: bemit('o-page-part', ['back-booking']) + ' u-margin-top-30'
    }, /*#__PURE__*/React.createElement("div", {
      className: "u-full-width u-text-center"
    }, book_btn)) : /*#__PURE__*/React.createElement("div", {
      className: "u-full-width u-text-center"
    }, book_btn);
    return /*#__PURE__*/React.createElement(Fragment, null, window.innerWidth <= 1200 ? props['cart-widget'] : undefined, props['white-label-booking'] ? /*#__PURE__*/React.createElement("div", {
      className: bemit('c-direct-booking_header', ['services', 'white-label-booking'])
    }, go_back_btn, book_btn) : props?.fromBack ? /*#__PURE__*/React.createElement("div", {
      className: "back-booking-header"
    }, go_back_btn, book_btn) : /*#__PURE__*/React.createElement("div", {
      className: "u-full-width u-text-center"
    }, book_btn), /*#__PURE__*/React.createElement("h2", {
      className: bemit('c-title', ['cart-services'].concat(props['white-label-booking'] ? ['white-label-booking'] : []))
    }, "Les services"), categories, bottom_btn);
  }
}
